import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Button, IconButton, InputAdornment, TextField, Box } from "@mui/material";
import { userLogin } from "../../features/auth/actions";
import { Visibility as ShowPWIcon, VisibilityOff as ShowPWOffIcon } from "@mui/icons-material";
import clarityLogo from "../../app/assets/images/clarity/app_logo.png";
import danaireLogo from "../../app/assets/images/danaire/app_logo.png";
import agelessindLogo from "../../app/assets/images/agelessind/app_logo.png";
import clarityDevLogo from "../../app/assets/images/clarity_dev/app_logo.png";
import froidLogo from "../../app/assets/images/froid/app_logo.png";

const Login = () => {
  const { loading, userInfo, error } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const { register, handleSubmit } = useForm();
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const clientName = useSelector((state) => state.common.clientName);

  const getClientLogo = (clientName) => {
    switch (clientName) {
      case "danaire":
        return danaireLogo;
      case "agelessind":
        return agelessindLogo;
      case "clarity_dev":
        return clarityDevLogo;
      case "clarity":
        return clarityLogo;
      case "froid":
        return froidLogo;
      default:
          return null;
    }
  };

  // redirect authenticated user to profile screen
  useEffect(() => {
    if (userInfo) {
      navigate("/");
    }
  }, [navigate, userInfo]);

  const submitForm = (data) => {
    dispatch(userLogin(data));
  };

  return (
    <Box
      component="div"
      sx={{
        marginTop: 20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box component="img" src={getClientLogo(clientName)} sx={{ height: 250, mt: -13 }} />
      <Box component="form" onSubmit={handleSubmit(submitForm)} noValidate sx={{ mt: -5 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="Username"
          name="username"
          autoComplete="email"
          autoFocus
          error={error}
          {...register("username")}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type={showPassword ? "text" : "password"}
          id="password"
          autoComplete="current-password"
          {...register("password")}
          error={error}
          helperText={error ? error : ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                  {showPassword ? <ShowPWIcon /> : <ShowPWOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {/* {error ? (
          <InputLabel fullWidth margin="normal" sx={{ color: "red" }}>
            Error
          </InputLabel>
        ) : null} */}
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading}>
          Sign In
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
